import React from 'react';
import gql from 'graphql-tag';

import { ShopBadges } from './shop_badges';
import { RCStarRating } from '@reverbdotcom/cadence/components';
import CoreLink from './core_link';
import { SellerInfoData } from '../rql';
import { SHOP_PATH } from '../url_helpers';

interface IProps {
  listing: SellerInfoData.Fragment;
  linkShop?: boolean;
  hideBadges?: boolean;
}

export default class SellerInfo extends React.Component<IProps, null> {
  renderShopName() {
    const { name, slug } = this.props.listing.shop;
    if (!this.props.linkShop) return name;

    return (
      <CoreLink to={SHOP_PATH.expand({ slug })}>
        {name}
      </CoreLink>
    );
  }

  renderShopBadges() {
    if (this.props.hideBadges) return null;

    const { preferredSeller, quickResponder, quickShipper } = this.props.listing.shop;

    return (
      <ShopBadges
        preferredSeller={preferredSeller}
        quickShipper={quickShipper}
        quickResponder={quickResponder}
        smallBadges
        hideLabels
      />
    );
  }

  render() {
    if (!this.props.listing.shop || !this.props.listing.seller) {
      return (
        <div className="seller-info"></div>
      );
    }

    const { receivedCount, rollingRatingPercentage } = this.props.listing.seller.feedbackSummary;
    const rating = rollingRatingPercentage / 100;

    return (
      <div className="seller-info">
        <div className="seller-info__name">
          {this.renderShopName()}
        </div>
        <div className="seller-info__location">
          {this.props.listing.shop.address.displayLocation}
        </div>
        <RCStarRating
          rating={rating}
          count={receivedCount}
        />
        <div className="seller-info__badges">
          {this.renderShopBadges()}
        </div>
      </div>
    );
  }
}

export const SellerInfoFragment = gql`
  fragment SellerInfoData on Listing {
    _id
    seller {
      _id
      feedbackSummary {
        receivedCount
        rollingRatingPercentage
      }
    }
    shop {
      _id
      name
      slug
      preferredSeller
      quickShipper
      quickResponder
      address {
        displayLocation
      }
    }
  }
`;
